module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "copyright-page",
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "_cip",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Copyright Information")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("The Eclectic Witch’s Book of Shadows")]), _vm._v(" © 2021 by Deborah Blake. ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any matter whatsoever, including Internet usage, without written permission from Llewellyn Publications, except in the form of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("As the purchaser of this e-book, you are granted the non-exclusive, non-transferable right to access and read the text of this e-book on screen. The text may not be otherwise reproduced, transmitted, downloaded, or recorded on any other storage device in any form or by any means. ")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Any unauthorized usage of the text without express written permission of the publisher is a violation of the author’s copyright and is illegal and punishable by law.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("First e-book edition © 2021")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("E-book ISBN: 9780738765563")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Art direction by Lynne Menturweck and Shira Atakpu"), _c('br'), _vm._v("Book design, layout, and edit by Rebecca Zins"), _c('br'), _vm._v("Cover design by Shira Atakpu"), _c('br'), _vm._v("Cover and interior illustrations by Mickie Mueller")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Names: Blake, Deborah, author.  ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Title: The eclectic witch’s book of shadows : witchy wisdom at your ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   fingertips / Deborah Blake.  ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Description: First edition. | Woodbury, Minnesota: Llewellyn Publications, ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   [2021] | Summary: “This beginner-friendly guide is modeled on a ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   traditional Wiccan Book of Shadows but is flexible enough to be ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   personalized. With sections on herbs, stones, spells, rituals, candle ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   magic, divination, correspondences, magical recipes, and more, this book ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   makes practicing Witchcraft easier, simpler, and more fun”—Provided by ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   publisher.  ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Identifiers: LCCN 2021005118 (print) | LCCN 2021005119 (ebook) | ISBN ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   9780738765327 (hardcover) | ISBN 9780738765563 (ebook)  ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Subjects: LCSH: Witchcraft. ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Classification: LCC BF1566 .B53434 2021  (print) | LCC BF1566  (ebook) | ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   DDC 133.4/3—dc23 ")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("LC record available at "), _c('span', {
    staticClass: "hyperlink"
  }, [_vm._v("https://lccn.loc.gov/2021005118")])]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("LC ebook record available at "), _c('span', {
    staticClass: "hyperlink"
  }, [_vm._v("https://lccn.loc.gov/2021005119")])]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn Publications does not participate in, endorse, or have any authority or responsibility concerning private business arrangements between our authors and the public.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Any Internet references contained in this work are current at publication time, but the publisher cannot guarantee that a specific reference will continue or be maintained. Please refer to the publisher’s website for links to current author websites.")]), _vm._v(" "), _c('p', {
    staticClass: "cip3-spab-cntr"
  }, [_vm._v("Llewellyn Publications ")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("2143 Wooddale Drive")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("Woodbury, MN 55125")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_c('a', {
    attrs: {
      "href": "http://www.llewellyn.com",
      "target": "_blank"
    }
  }, [_vm._v("www.llewellyn.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cip3-spab-cntr"
  }, [_vm._v("Manufactured in the United States of America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710f8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 63
// module chunks = 0